const mediaQuestion = {
  setting: {
    type: 'media',
    showInLoop: false,
    fullscreen: false,
  },
}
export default mediaQuestion
